import { createFileRoute, redirect } from '@tanstack/react-router'
import { CategoryList } from '@/features/landed-cost-categories/category-list'
import { hasGrant } from '@/lib/me'

/** Route shell for the landed-cost categories (purchasing setup). */
export const Route = createFileRoute('/_authenticated/purchasing/landed-cost-categories')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'landed_cost_category.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: CategoryList,
})
